import axios from 'axios'

export const appdepAjax = axios.create({
  baseURL: '/appdep-service',
  // 斑马数据测试环境查询需要15秒左右时间，所以暂时先配置成20秒
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true
})

export const appdepFileAjax = axios.create({
  timeout: 30000
})



// WEBPACK FOOTER //
// ./src/libs/ajax/appdep.js